<template>
    <el-row>
        <!-- 地址列 -->
        <el-col :span="12">
            <cart-order-address-item
                :address-item="select_address"
                v-if="!!select_address.address_id">
            </cart-order-address-item>
        </el-col>
        <!-- 按钮列 -->
        <el-col :span="12" :offset="select_address.address_id?0:12">
            <div class="cart_order_submit_box">
                <el-button
                    type="primary"
                    @click="handleSubmit"
                    class="cart_order_submit_btn">
                    <span>{{$t("public.submitBtn")}}</span>
                </el-button>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Bus from '@/utils/Bus'
import { $debounce } from "@/utils/publicMethod";

export default {
    data() {
        return {
            department_id: "",
            remark: ""
        }
    },
    computed: mapState({
        cart_order: state => state.order.cart_order,
        select_address: state => state.order.select_address,
        limit_month: state => state.order.limit_month, // 月限制
        limit_amount: state => state.order.limit_amount, // 单笔限制
        totalPrice(){
            let price = 0;
            for(let item of this.cart_order){
                price += Number(item.goods_number) * Number(item.goods_price);
            }
            return price
        }
    }),
    components: {
        cartOrderAddressItem: () => import("@/components/cartOrderAddressItem")
    },
    methods: {
        ...mapActions([
            "submitCartOrder",
			"getOrderStatusDetail",
            "getCart"
        ]),
        handleSubmit: $debounce(function() { // 提交订单
            let to_price = this.totalPrice,
            am = this.limit_amount,
            m = this.limit_month;
            if((m === ""|| m > to_price) &&(am === ""|| am > to_price)){
				// console.log("查看",1)
				// 限制金额
                if(!this.select_address.address_id){
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cart.errmsg3"),
                        type: "error"
                    })
                    return
                }
                this.submitCartOrder({
                    department_id: this.department_id,
                    remark: this.remark
                }).then((res) => {
					if(res.type == 1){
					    // this.$message({
					    //     showClose: true,
					    //     message: this.$t("message.cart.succmsg"),
					    //     type: "success"
					    // })
					    this.getCart();
					    this.$router.push({path:"/center/cart",query: {id:res.order_id}});
					}else if(res.type == 3){
					    this.$message({
					        showClose: true,
					        message: res.msg,
					        type: "warning"
					    })
					    this.getCart();
					    this.$router.push("/center/cart");
					}else if(res.type == 2){
					    this.$message({
					        showClose: true,
					        message: this.$t("message.cart.errmsg5"),
					        type: "error"
					    })
					}else if(res.type == 4){
					    this.$message({
					        showClose: true,
					        message: this.$t("message.cart.errmsg"),
					        type: "error"
					    })
					}
					else if(res.type == 8){
					    this.$message({
					        showClose: true,
					        message: this.$t("message.cart.errmsg6"),
					        type: "error"
					    })
					}
			
                    // if(res.type == 1){
                    //     this.$message({
                    //         showClose: true,
                    //         message: this.$t("message.cart.succmsg"),
                    //         type: "success"
                    //     })
                    //     this.getCart();
                    //     this.$router.push("/center/cart");
                    // }else if(res.type == 3){
                    //     this.$message({
                    //         showClose: true,
                    //         message: res.msg,
                    //         type: "warning"
                    //     })
                    //     this.getCart();
                    //     this.$router.push("/center/cart");
                    // }else{
                    //     this.$message({
                    //         showClose: true,
                    //         message: this.$t("message.cart.errmsg5"),
                    //         type: "error"
                    //     })
                    // }
                })
            }else{
                this.$message({
                    showClose: true,
                    message: this.$t("message.cart.errmsg"),
                    type: "warning"
                })
            }
        }, 200)
    },
    created() {
        Bus.$on("cartOrderDepartment", (val) => {
            this.department_id = val.department;
            this.remark = val.remark;
        })
    },
}
</script>

<style scoped>
.cart_order_submit_box{
    text-align: right;
}
/* 按钮 */
.cart_order_submit_btn{
    width: 160px;
    height: 60px;
}
</style>
